import { useInView } from 'react-intersection-observer'
import { motion } from 'framer-motion'
import type { Language } from '../App'
import { t } from '../utils/translations'
import { skills } from '../utils/data'
import './Skills.css'

interface SkillsProps { language: Language }

export default function Skills({ language }: SkillsProps) {
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true })

  const containerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.1 } },
  }

  const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.6, ease: [0.4, 0, 0.2, 1] } },
  }

  return (
    <section id="skills" className="skills-section section-alt" ref={ref}>
      <div className="orb orb-purple skills-orb" />

      <div className="container">
        <motion.div
          className="section-header"
          initial={{ y: 30, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0}}
        >
          <p className="section-label">{t('skills.label', language)}</p>
          <h2 className="section-title">{t('skills.title', language)}</h2>
          <div className="gradient-divider" />
          <p className="section-desc">{t('skills.desc', language)}</p>
        </motion.div>

        <motion.div
          className="skills-grid"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
        >
          {skills.map((category, ci) => (
            <motion.div key={ci} className="skill-card card" variants={cardVariants}>
              <div className="skill-card__header">
                <span className="skill-icon">{category.icon}</span>
                <h3 className="skill-category">{category.category}</h3>
              </div>

               <div className="skill-items">
                  {category.items.map((skill, si) => (
                    <span key={si} className="tag">{skill.name}</span>
                  ))}
                </div>

              {/* <div className="skill-items">
                {category.items.map((skill, si) => (
                  <div key={si} className="skill-item">
                    <div className="skill-item__meta">
                      <span className="skill-name">{skill.name}</span>
                      <span className="skill-pct">{skill.level}%</span>
                    </div>
                    <div className="skill-bar">
                      <motion.div
                        className="skill-bar__fill"
                        initial={{ width: 0 }}
                        animate={inView ? { width: `${skill.level}%` } : { width: 0 }}
                        transition={{ duration: 1, delay: ci * 0.1 + si * 0.07, ease: [0.4, 0, 0.2, 1] }}
                      />
                    </div>
                  </div>
                ))}
              </div> */}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}
